export default __webpack_public_path__ + "static/media/mifoto.c80d224b.jpg";